import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/components/ErrorBoundary.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/components/Layout.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/features/auth/ProtectedRoute.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/features/careers/CareersListPage.tsx")